"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chapterClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var chapterClick = function (event) {
    var _a;
    return {
        event: analytics_layer_1.ButtonInteractionEventNames.ChapterClick,
        eventInfo: analytics_layer_1.ButtonInteractionEventNames.ChapterClick,
        chapterName: ((_a = event === null || event === void 0 ? void 0 : event.eventData) === null || _a === void 0 ? void 0 : _a.chapterName) || consts_1.NOT_AVAILABLE,
    };
};
exports.chapterClick = chapterClick;
